// extracted by mini-css-extract-plugin
export default {"root":"styles_root__-PVvn","list":"styles_list__anWdT"};